/*
  Shoes Egy — products-per-row control.

  Swaps Dawn's own grid--N-col-desktop / grid--N-col-tablet-down classes on
  #product-grid. Nothing else: no facet params, no refetch, no round-trip.
  The choice is kept for the session only.

  Two instances render — one in the desktop sort row, one in the mobile bar —
  because Dawn hides the desktop facet form below 750px. They share storage and
  keep each other in sync.

  Dawn replaces #ProductGridContainer wholesale on every filter or sort change,
  which resets the grid's classes, so a MutationObserver reapplies the choice
  after each of those swaps.
*/
(function () {
  var KEY_DESKTOP = 'shoesegy:cols:desktop';
  var KEY_MOBILE = 'shoesegy:cols:mobile';
  var MOBILE_QUERY = '(max-width: 749px)';

  var DESKTOP_ALLOWED = [2, 4, 6];
  var MOBILE_ALLOWED = [1, 2];
  var DESKTOP_DEFAULT = 4;
  var MOBILE_DEFAULT = 2;

  var instances = [];

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function read(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      // private mode or storage disabled: the control still works, it just
      // will not survive a page change
      return null;
    }
  }

  function write(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      /* nothing to do */
    }
  }

  // Only ever return a column count the grid actually has a rule for.
  function resolve(raw, allowed, fallback) {
    var n = parseInt(raw, 10);
    return allowed.indexOf(n) === -1 ? fallback : n;
  }

  function currentDesktop() {
    return resolve(read(KEY_DESKTOP), DESKTOP_ALLOWED, DESKTOP_DEFAULT);
  }

  function currentMobile() {
    return resolve(read(KEY_MOBILE), MOBILE_ALLOWED, MOBILE_DEFAULT);
  }

  function applyAll() {
    var grid = document.getElementById('product-grid');
    if (grid) {
      var desktop = currentDesktop();
      var mobile = currentMobile();

      // Rewrite only a class Dawn actually rendered, so an unexpected grid
      // shape is left exactly as the theme built it.
      if (/grid--\d-col-desktop/.test(grid.className)) {
        grid.className = grid.className.replace(/grid--\d-col-desktop/, 'grid--' + desktop + '-col-desktop');
      }
      if (/grid--\d-col-tablet-down/.test(grid.className)) {
        grid.className = grid.className.replace(
          /grid--\d-col-tablet-down/,
          'grid--' + mobile + '-col-tablet-down'
        );
      }
    }

    var active = isMobile() ? currentMobile() : currentDesktop();
    instances.forEach(function (el) {
      el.reflect(active);
    });
  }

  class GridDensity extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.shoes-density__btn'));
      this.buttons.forEach(
        function (button) {
          button.addEventListener('click', this.onClick.bind(this));
        }.bind(this)
      );

      instances.push(this);
      this.watchGrid();
      this.watchBreakpoint();
      applyAll();
    }

    disconnectedCallback() {
      var i = instances.indexOf(this);
      if (i > -1) instances.splice(i, 1);
      if (this.observer) this.observer.disconnect();
      if (!this.mql) return;
      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onBreakpoint);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onBreakpoint);
      }
    }

    onClick(event) {
      var cols = event.currentTarget.getAttribute('data-cols');
      if (isMobile()) {
        write(KEY_MOBILE, String(resolve(cols, MOBILE_ALLOWED, MOBILE_DEFAULT)));
      } else {
        write(KEY_DESKTOP, String(resolve(cols, DESKTOP_ALLOWED, DESKTOP_DEFAULT)));
      }
      applyAll();
    }

    reflect(active) {
      this.buttons.forEach(function (button) {
        var on = parseInt(button.getAttribute('data-cols'), 10) === active;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.classList.toggle('is-active', on);
      });
    }

    watchBreakpoint() {
      this.mql = window.matchMedia(MOBILE_QUERY);
      this.onBreakpoint = applyAll;
      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onBreakpoint);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onBreakpoint);
      }
    }

    watchGrid() {
      var container = document.getElementById('ProductGridContainer');
      if (!container || !window.MutationObserver) return;

      var scheduled = false;
      this.observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          applyAll();
        });
      });

      this.observer.observe(container, { childList: true, subtree: true });
    }
  }

  if (!customElements.get('grid-density')) {
    customElements.define('grid-density', GridDensity);
  }
})();
